<template>
	<section class="page">
		<div :style="{'height': conH +'px'}" class="con">
			<status v-if="tabIndex==0" ref="status"></status>
			<order-list v-if="tabIndex==1"></order-list>
			<mine v-if="showMine" @tapBg="closePop" />
		</div>
		<div ref="btn" class="btn tBor" v-show='isShowTab'>
			<a @click="tabIndex=0" :class="{'btn-a1': tabIndex == 0}">Home</a>
			<a @click="changeTab(1)" :class="{'btn-a2': tabIndex == 1}">Order</a>
			<a @click="changeTab(2)">My</a>
		</div>
		<service></service>
	</section>
</template>

<script>
	import orderList from './orderList'
	import status from "./status";
	import mine from "../my/mine.vue";
	import service from "@components/service";
	export default {
		data() {
			return {
				conH: '',
				tabIndex: this.UTILS.getQueryString('tab') || 0,
				showMine: false,
				deviceId: '',
				isShowTab:true
			}
		},
		components: {
			status,
			orderList,
			mine,
			service
		},
		
		created(){
			this.UTILS.removeParam("moneyAmount");
			this.UTILS.removeParam("exchangeId");
			this.UTILS.removeParam("couponName");
			this.UTILS.removeParam("couponType");
			this.UTILS.removeParam("fqMoneyAmount");
			this.UTILS.removeParam("fqExchangeId");
			this.UTILS.removeParam("fqCouponName");
			this.UTILS.removeParam("fqCouponType");
			this.UTILS.removeParam('periods');
			this.UTILS.removeParam('amount');
			this.tabIndex = this.UTILS.getQueryString("tab") || 0;
			//app内嵌页面交互
			const phone = this.UTILS.getQueryString("phone") || "09270023183";
			var cToken = "";
			const cTime = this.UTILS.getParam('cTime');
			const preLoginTime = cTime && new Date(cTime).toDateString(); //前一次自动登录时间
			const curLoginTime = new Date().toDateString();
			const registerSource = this.UTILS.getQueryString("registerSource");//fb广告渠道来源
			if(registerSource){
				this.UTILS.setParam('registerSource',registerSource);
			}
			if(phone){//不同域名可能对应不同客服电话
				this.UTILS.setParam('phone',phone);
			}
			
			try{//安卓app
				cToken = funpera.getTokenFromApp();
				this.deviceId = funpera.getDeviceIdFromApp();
				this.UTILS.setParam('cToken', cToken);
				this.UTILS.setParam('deviceId', this.deviceId);
			}catch(e){
				if(this.UTILS.getEnv()){//ios app
					cToken = this.UTILS.getQueryString("cToken");
					this.deviceId = this.UTILS.getQueryString("deviceId");
					this.UTILS.setParam('cToken', cToken);
					this.UTILS.setParam('deviceId', this.deviceId);
				}
				else{
					cToken = this.UTILS.getParam('cToken');
				}
			}
			if(this.UTILS.getEnv()){//ios app
				this.isShowPage = true;
				this.isShowTab = false;
			}
			else{
				this.isShowTab = true;
				this.isShowPage = true;
			}
			
			if(cToken){
				if(!preLoginTime || preLoginTime !== curLoginTime){//判断是否同一天
					this.autoLogin()
				}
			}
		},
		
		mounted: function() {
			var self = this;
			self.conH = window.innerHeight - self.$refs.btn.offsetHeight;
			window.addEventListener('resize', function() {
				self.conH = window.innerHeight - self.$refs.btn.offsetHeight;
			});
		},
		methods: {
			//关闭我的
			closePop(){
				var self = this;
				self.showMine = false;
			},
			
			changeTab(val){
				const cToken = this.UTILS.getParam('cToken');
				this.UTILS.removeParam("source");
				if(cToken){
					if(val === 1){
						this.tabIndex = 1
					}
					else{
						this.showMine = true
					}
				}
				else{
					location.href = "./login.html"
				}
			},
			
			// 自动登录
			autoLogin() {
				var self = this;
				self.UTILS.axiosRequest('post', self.PATHS.loanPath + '/user/autoLogin', {
					deviceId: self.UTILS.getParam('deviceId')
				}, function(res) {
					self.UTILS.loadGif.hide();
					if (res.code == '0000') {
						if(res.data){
							self.UTILS.setParam('cToken', res.data);
							self.UTILS.setParam('cTime', new Date());
						}
						else{
							self.UTILS.removeParam('cToken');
							self.UTILS.removeParam('cTime');
						}
					} else {
						self.UTILS.removeParam('cToken');
						self.UTILS.removeParam('cTime');
						self.UTILS.logStr(res.message);
					}
				}, 1);
			}
		}
	}
</script>

<style scoped>
	@import "../../assets/css/onePx.css";

	.con {
		overflow: auto;
	}

	.btn {
		height: 0.97rem;
		line-height: 0.96rem;
		background-color: #FFF;
		position: relative;
	}

	.btn a {
		width: 33.33%;
		padding-top: 0.58rem;
		line-height: 0.3rem;
		text-align: center;
		font-size: 0.28rem;
		color: #BFBDBD;
		float: left;
	}

	.btn a:nth-child(1) {
		background: url("./img/tab1.png") no-repeat center 0.1rem;
		background-size: 0.4rem 0.44rem;
	}

	.btn a:nth-child(2) {
		background: url("./img/tab2.png") no-repeat center 0.1rem;
		background-size: 0.37rem 0.44rem;
	}
	.btn a:nth-child(3) {
		background: url("./img/tab3.png") no-repeat center 0.1rem;
		background-size: 0.4rem 0.4rem;
	}

	.btn a.btn-a1 {
		background: url("./img/selectTab1.png") no-repeat center 0.1rem;
		background-size: 0.4rem 0.44rem;
		color: #ED7D31;
	}

	.btn a.btn-a2 {
		background: url("./img/selectTab2.png") no-repeat center 0.1rem;
		background-size: 0.37rem 0.44rem;
		color: #ED7D31;
	}
</style>
